export enum PanelViews {
    AD = 'ad',
    ASSETS = 'assets',
    BUNDLES = 'bundles',
    VIDEO_BUNDLES = 'videoBundles',
    FILTER = 'filter',
    TEARSHEETS = 'tearsheets',
    TEMPLATES = 'templates',
    NONE = 'none',
}
